export default __webpack_public_path__ + "static/tree_dead_2-001c6d1df636aa0b3924be8ef1f4d120.jpg";